import { Response } from 'superagent'

export interface SessionApiResponse {
  session: {
    id: string
    version: number
    startAt: number
  }
}

export type SessionCookieErrorCode =
  'invalid_cookie' // 送信したセッションcookieが不正
  | 'not_found' // セッションがサーバー側に存在しない
export type ShopEntryErrorCode = 'entry_rejected' // 入店拒否
export type UnknownErrorCode = 'unknown'

export interface SessionApiErrorResponse {
  error_code: SessionCookieErrorCode | ShopEntryErrorCode
}

export class SessionApiErrorResponse {
  public static fromResponse(response: Response): SessionApiErrorResponse {
    const body = response.body

    return new SessionApiErrorResponse(
      body.error_code || 'unknown',
      body.message || ''
    )
  }

  public static fromString(message: string): SessionApiErrorResponse {
    return new SessionApiErrorResponse('unknown', message)
  }

  constructor(
    public readonly errorCode: SessionCookieErrorCode | ShopEntryErrorCode | UnknownErrorCode,
    public readonly message: string
  ) {}
}
